document.addEventListener('click', async function (event) {

  const buyNowButton = event.target.closest('.ww-buy-now-btn');

  if (!buyNowButton) return;

  event.preventDefault();

  buyNowButton.disabled = true;
  buyNowButton.innerText = 'Processing...';

  try {

    const variantInput = document.querySelector('input.product-variant-id');

    if (!variantInput) {
      alert('Variant not found.');
      return;
    }

    const quantityInput = document.querySelector('quantity-input input');

    const variantId = variantInput.value;

    const quantity = quantityInput
      ? parseInt(quantityInput.value)
      : 1;

    const response = await fetch('/cart/add.js', {

      method: 'POST',

      headers: {
        'Content-Type': 'application/json'
      },

      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })

    });

    if (!response.ok) {
      throw new Error('Unable to add product.');
    }

    window.location.href = '/checkout';

  } catch (error) {

    console.error(error);

    alert('Something went wrong. Please try again.');

    buyNowButton.disabled = false;
    buyNowButton.innerText = '⚡ Buy it now';

  }

});